<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Supervisor Access</h3>
           </template>
           <breadcrumb-menu></breadcrumb-menu>
           <!-- SEARCH BY USERNAME -->
           <div class="row">
              <div class="col-md-10">
                 <p><i class="fa fa-search"></i> Search Employee</p>
                 <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
              </div>
              <div class="col-md-1">
                 <div class="form-group">
                    <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                    <select v-model="order_by" class="form-control" required>
                       <option value="">Default</option>
                       <option value="-1">ASC</option>
                       <option value="1">DESC</option>
                    </select>
                 </div>
              </div>
              <div class="col-md-1">
                 <div class="form-group">
                    <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                    <select v-model="page_limit" class="form-control" required>
                       <option value="">Default</option>
                       <option value="5">5</option>
                       <option value="10">10</option>
                       <option value="25">25</option>
                       <option value="50">50</option>
                       <option value="100">100</option>
                       <option value="500">500</option>
                    </select>
                 </div>
              </div>
           </div>
           <hr/>
           <div class="table-responsive ">
              <table class="table table-striped table-hover " v-loading="loading">
                 <thead>
                    <tr>
                       <th width="20" >#</th>
                       <th>Full Name</th>
                       <th width="500"></th>
                       <th width="200"></th>
                       <th width="200"></th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr v-for="(item,i) in computedEmployee">
                       <template v-if="item === 'no data found'">
                          <td colspan="100%">
                             <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                          </td>
                       </template>
                       <template v-else>
                          <td>{{i+1}}</td>
                          <td>{{item.full_name | capitalize}}</td>
                          <td>Belongs to <b> <i class="fa fa-long-arrow-right"></i> {{item.superior_name | capitalize}} </b></td>
                          <td>       
                              <slot v-if="item.belong == null">No team member</slot>
                                <slot v-else="item.belong != null">
                                  Has<i class="fa fa-long-arrow-right"></i> 
                                    <span class="badge badge-pill badge-danger">
                                        {{item.belong}}  
                                    </span> 
                                     <b> Member </b>
                              </slot>
                         </td>
                          <td>Module Access 
                               <input type="checkbox" :checked="item.module_access == '1'" @click="subordinateStatus(item.id,item.module_access)" > 
                          </td>
                          <td><a href="#" @click="get_selected_empId(item)" v-if="item.module_access == '1'" v-b-modal.update-subordinate><u>Subordinates</u></a></td>
                          <td><a href="#" @click="get_selected_id(item)" v-b-modal.update-user-account><u>Change Access</u></a></td>
                       </template>
                    </tr>
                 </tbody>
              </table>
           </div>
           <!-- MODAL FOR UPDATE RECORD  -->
           <b-modal id="update-user-account" ref="hide-user-modal"  size="l"  hide-footer  @hide="modalClose">
              <h3>{{selected_item.full_name | capitalize}}</h3>
              <div class="form-group">
                 <label>Account Type:</label>
                 <select class="form-control" v-model="options" @change="get_subtitute">
                    <option value="">--Select One--</option>
                    <option value="staff">OFFICE STAFF</option>
                    <option value="admin">ADMIN STAFF</option>
                    <option value="supervisor">SUPERVISOR</option>
                    <option value="asm">MANAGER</option>
                 </select>
              </div>
              <slot v-if="subtitute_item == true">
                 <div class="form-group">
                    <label>Select Supervisor to Subtitute</label>
                    <select class="form-control" v-model="sup_subtitute_id">
                       <option value="">--Select One--</option>
                       <option v-for="sup in supervisor" v-bind:value="sup.id">{{sup.full_name | capitalize}} - {{sup.position_name}}</option>
                    </select>
                 </div>
              </slot>
              <slot v-if="supervisor_choosen == true">
                 <div class="form-group">
                    <label>Select Employee Supervisor</label>
                    <select class="form-control" v-model="sup_choosen_id">
                       <option value="">--Select One--</option>
                       <option v-for="sup in supervisor" v-bind:value="sup.id">{{sup.full_name | capitalize}} - {{sup.position_name}}</option>
                    </select>
                 </div>
              </slot>
              <div class="form-group">
                <div v-if="options == 'supervisor'">
                   <label>Belongs to:</label>      
                   <select class="form-control" v-model="sup_choosen_id" @change="get_manager">
                      <option value="">-- Select Manager --</option>
                      <option v-for="mag in manager" v-bind:value="mag.id">{{mag.full_name | capitalize}} - {{mag.position_name | capitalize}}</option>
                   </select>
                </div>
             </div>
              <div class="form-group">
                 <button class="btn btn-info float-right" @click="update_user"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
              </div>
              <br/> <br/> 
           </b-modal>
           <!-- MODAL FOR SUBOTDINATES -->
            <b-modal id="update-subordinate" ref="hide-subordinate-modal"  size="l"  hide-footer  @hide="modalClose">
            <h1><h3>{{subordinate_item.full_name | capitalize}}</h3></h1>
            <p>Select Subordinates for Managerial Belongs:</p>
                <hr/>
            

                <h6>SUB DEPARTMENT / SUBORDINATES</h6>
                    <div class="subordinatesSytle">
                        <span v-for="item in sub_department" >
                            <input type="checkbox" class="perm_id" v-bind:value="item.id" name="perm_id" id="perm_name" v-model="checkedPerm_Id"> {{item.sub_department_name}}<br>
                        </span>
                    </div>
                    <!-- <span>Checked names: {{ checkedPerm_Id }}</span> -->


                    <div class="form-group mt-3">
                        <button class="btn btn-info float-right" @click="update_subordinate"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                    </div>
            
                
            </b-modal>
        </card>
     </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'  
    import breadcrumbMenu from './base-breadcrumb-menu'
    export default {
       components: {
           Card,
           breadcrumbMenu
       },
       data(){
            return{
                items:[],
                loading: true,
                belongs_to:'',
                selected_item:'',
                //options
                supervisor:[],
                manager:[],
                 //filter
                search: '',
                order_by: '',
                sortAsc: true,
                 //pagination
                page_limit: '',
                start_page: 1,
                loading: true,
                options:'',
                sup_subtitute_id:'',
                sup_choosen_id:'',
                member_item:'',
                subtitute_item:false,
                supervisor_choosen:false,

                subordinate_item:[],
                checkedPerm_Id:[],
                sub_department: [],
                status_control:''
            }
        },
    
        mounted: function() {
          this.get_users()
          this. get_supervisor()
          this.get_manager()
          this.get_subtitute()
          this.get_sub_department()
       },
    
        methods:{ 
  
                subordinateStatus(id,status){
                    if(status == '1'){
                    this.status_control = '0'
                    }else if(status == '0'){
                    this.status_control = '1'
                    }

                    axios.post('api/updateStatus',{
                        id:id,
                        status:this.status_control
                    })
                    .then(resp => {
                        this.get_users()
                    })
                },
            //GET SUB DEPARTMENT
            get_sub_department(){
                axios.get('api/subdepartment/all')
                    .then(response => {   this.sub_department = response.data; this.loading = false; })  
                    .catch(error => {  console.log(error) });
            },
           //GET MANAGER FOR SUBORDINATES DISPLAY
            get_selected_empId(item){
                 this.selected_emp = item;
                 //SUBORDINATES
                  axios.get('api/employee/'+ this.selected_emp.id)
                       .then(resp => { 
                            this.subordinate_item = resp.data;
                            this.checkedPerm_Id = this.subordinate_item.subordinates.map(o=>o.id)
                        })
                        .catch(error => { console.log(error.response) });
              },

          update_subordinate(){
                console.log('response =>',JSON.stringify(this.checkedPerm_Id ))
                console.log('response =>',JSON.stringify(this.selected_emp.id))
                
                axios.post('api/subordinates/update',{
                       id: this.selected_emp.id,
                       subordinates: JSON.stringify(this.checkedPerm_Id)
                    })
                    .then(resp => {
                        if(resp.data.response == 'success'){
                          this.get_sub_department()
                          this.$swal('Save',resp.data.message, 'success')
                          this.$refs['hide-subordinate-modal'].hide();
                        }else{
                          this.$swal('Error',resp.data.message,'error')
                        }  
                    })      
                   .catch(error => {console.log(error);});
            },

            get_manager(){
                axios.get('api/operation')
                  .then(resp => { this.manager = resp.data; })
                  .catch(error => { console.log(error.response) });
             },

             modalClose(){
                    this.subtitute_item = false,
                    this.supervisor_choosen = false
             },

            get_subtitute(){
                if(this.options == 'admin' && this.member_item.length != 0){
                    this.subtitute_item = true
                    this.supervisor_choosen = false 
                }else if(this.options == 'staff' && this.member_item.length != 0){
                    this.subtitute_item = true
                    this.supervisor_choosen = true
                }else if(this.options == 'asm' && this.member_item.length != 0){
                    this.subtitute_item = true
                    this.supervisor_choosen = false
                }else if(this.options == 'staff'){
                    this.supervisor_choosen = true
                }else{
                    this.subtitute_item = false
                    this.supervisor_choosen = false
                }
            },
             get_supervisor(){
             axios.get('api/supervisor')
                  .then(resp => { this.supervisor = resp.data; })
                  .catch(error => { console.log(error.response) });
              },

           //SUPERVISOR ACCESS
              get_users(){
                axios.get('api/supervisoraccess')
                    .then(response => {   this.items = response.data; this.loading = false; console.log('response =>',response.data)})  
                    .catch(error => {  console.log(error) });
              },
    
              get_selected_id(item) {
                   this.selected_item = item;
                   axios.get('api/checkmember/'+ this.selected_item.id)
                        .then(resp => { this.member_item = resp.data; console.log(this.member_item.length)})
                        .catch(error => { console.log(error.response) });
              },

             //UPDATE USER BELONGS
              update_user(){
                    axios.post('api/supervisoraccess/update/' + this.selected_item.id,{
                             'supervisor_member':this.member_item.length,
                             'account_type':this.options,
                             'sup_subtitute_id':this.sup_subtitute_id,
                             'supervisor_choosen_id':this.sup_choosen_id,
                    })
                    .then(resp => {
                        if(resp.data.response == 'success'){
                          this.get_users();
                          this.$swal('Save',resp.data.message, 'success')
                          this.$refs['hide-user-modal'].hide();
                        }else{
                          this.$swal('Error',resp.data.message,'error')
                        }  
                    })      
                   .catch(error => {console.log(error);});
              },    
       },
computed: {
// PAGINATION
offset() {
   return ((this.start_page - 1) * this.page_limit);
},

limit() {
   return ((this.offset + this.page_limit));
},

total_record() {
   return this.items.length
},

numOfPages() {
   return Math.ceil(this.items.length / this.page_limit);
},


computedEmployee() {
   let filtered = this.items
    if(filtered.length > 0){
          // SEARCH BY EMPLOYEE FULLNAME  
          if (this.search) {
              filtered = filtered.filter(
              item => item.full_name.toLowerCase().indexOf(this.search) > -1
              );
              return filtered
          }

          // SORTING NUMBER OF DISPLAY
          if (this.page_limit) {
              filtered = filtered.slice(this.offset, this.limit)
              return filtered
          }

          // ORDER BY ASC AND DESC COMBOBOX
          if (this.order_by) {
              filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
              return filtered
          }
      }
    return filtered
  }
},

    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/todo-supervisor-account.vue